import { Add } from '@mui/icons-material';
import { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Button } from '../Button';

export type OptionalBehindButtonProps = {
  buttonText: string;
  children: React.ReactElement;
  className?: string;
  initialOpen?: boolean;
};

export const OptionalBehindButton: React.FC<OptionalBehindButtonProps> = ({ children, buttonText, className, initialOpen }) => {
  const { classes, cx } = useStyles();
  const [ show, setShow ] = useState(initialOpen ?? false);

  const handleClick = () => {
    setShow(true);
  };

  if (!show) {
    return (
      <Button
        variant="text"
        startIcon={<Add />}
        color="secondary"
        onClick={handleClick}
        className={cx(classes.hiddenFieldButton, className)}
      >
        {buttonText}
      </Button>
    );
  }

  return children;
};

const useStyles = makeStyles()({
  hiddenFieldButton: {
    fontSize: '1rem',
    fontWeight: 400,
    letterSpacing: '0.15px',
    lineHeight: '20px',
    textTransform: 'none',
    width: 'fit-content',
  },
});
